module.exports = __webpack_public_path__ + "static/media/Fairways_West_Park_Map.69b099b2.pdf";